/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
// import * as wjCore from "@grapecity/wijmo"
// import * as wjGrid from "@grapecity/wijmo.grid"
// import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
// import queryString from "query-string"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Prompt, useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"

import ComboBox from "../../../components/ComboBox"
import { T会社マスタ } from "../../../components/ComboBox/KaisyaComboBox"
import { T営業所マスタ } from "../../../components/ComboBox/EigyosyoComboBox"
import { T営業所管マスタ } from "../../../components/ComboBox/EigyosyokanComboBox"

import { showInfoToast } from "../../../components/CustomToast"
import TextInput from "../../../components/InputWrapper/TextInput"
import CheckInput from "../../../components/InputWrapper/CheckInput"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import CONSTANT from "../../../constant"
import { setAlerts, setWarningAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import BusyoService from "../../../service/master/busyo/busyoService"
import { TApiResponse } from "../../../service/TApiResponse"
import util from "../../../ts/util"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import Ajv, { ErrorObject } from "ajv"
import ajvErrors from "ajv-errors"
import {
  busyoRegisterPostReqSchema,
  busyoUpdatePutReqSchema,
} from "../../../service/master/busyo/busyoScheme"
import SikutyosonSearchModal from "../../../components/SearchModal/SikutyosonSearchModal"
import { T市区町村 } from "../../../service/master/sikutyoson/TSikutyoson"
import KaisyaService from "../../../service/master/kaisya/kaisyaService"
import EigyosyoService from "../../../service/master/eigyosyo/eigyosyoService"
import EigyosyoKanService from "../../../service/master/eigyosyoKan/eigyosyoKanService"
import BusyoKengenService from "../../../service/master/busyoKengen/BusyoKengenService"
import { T部所権限マスタ } from "../../../service/master/busyoKengen/TBusyoKengen"
import { メニューコード } from "../../../constant/menuCode"
import { RootState } from "../../../globalStore/rootreducer"

/**
 * 部所マスタ登録
 */
const MasterBusyoRegister = () => {
  const history = useHistory()
  const { id: paramId } = useParams<{ id: string }>()
  const id = paramId ? parseInt(paramId) : undefined
  const disPatch: AppDispatch = useDispatch()

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find(
        (m) => m.メニューコード === メニューコード.マスタ管理.部所マスタ登録
      )?.読み取り専用フラグ
  )

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //#region [state]

  // 表示項目のstate
  const [会社コード, set会社コード] = useState<string | null | undefined>(null)
  const [営業所管コード, set営業所管コード] = useState<
    string | null | undefined
  >(null)
  const [営業所コード, set営業所コード] = useState<string | null | undefined>(
    null
  )
  const [部所コード, set部所コード] = useState<string>()
  const [部所名, set部所名] = useState<string>()
  const [部所略称, set部所略称] = useState<string>()
  const [運行部所フラグ, set運行部所フラグ] = useState<0 | 1>(0)
  const [点呼場所団体コード, set点呼場所団体コード] = useState<string>()
  const [点呼場所市区町村名, set点呼場所市区町村名] = useState<string>()
  const [部所権限コード, set部所権限コード] = useState<
    string | null | undefined
  >(null)
  const [最終更新日時, set最終更新日時] = useState<string>()
  const [最終更新ID, set最終更新ID] = useState<string>()

  //　エラー表示用フラグ
  const [isInvalid会社コード, setIsInvalid会社コード] = useState<boolean>()
  const [isInvalid営業所管コード, setIsInvalid営業所管コード] =
    useState<boolean>(false)
  const [isInvalid営業所コード, setIsInvalid営業所コード] =
    useState<boolean>(false)
  const [isInvalid部所コード, setIsInvalid部所コード] = useState<boolean>(false)
  const [isInvalid部所名, setIsInvalid部所名] = useState<boolean>(false)
  const [isInvalid部所略称, setIsInvalid部所略称] = useState<boolean>(false)
  const [isInvalid点呼場所団体コード, setIsInvalid点呼場所団体コード] =
    useState<boolean>(false)
  const [isInvalid点呼場所市区町村名, setIsInvalid点呼場所市区町村名] =
    useState<boolean>(false)
  const [isInvalid部所権限コード, setIsInvalid部所権限コード] =
    useState<boolean>(false)

  //#region [comboboxState]

  // 会社ComboBox
  const [会社ComboBox, set会社ComboBox] = useState<TWijmoComboBox<
    string,
    T会社マスタ
  > | null>(null)
  const [会社ItemSource, set会社ItemSource] = useState<T会社マスタ[]>()
  const [会社isLoadEnded, set会社isLoadEnded] = useState<boolean>(false)

  // 営業所管ComboBox
  const [営業所管ComboBox, set営業所管ComboBox] = useState<TWijmoComboBox<
    string,
    T営業所管マスタ
  > | null>(null)
  const [営業所管ItemSource, set営業所管ItemSource] =
    useState<T営業所管マスタ[]>()
  const [営業所管isLoadEnded, set営業所管isLoadEnded] = useState<boolean>(false)

  // 営業所ComboBox
  const [営業所ComboBox, set営業所ComboBox] = useState<TWijmoComboBox<
    string,
    T営業所マスタ
  > | null>(null)
  const [営業所ItemSource, set営業所ItemSource] = useState<T営業所マスタ[]>()
  const [営業所isLoadEnded, set営業所isLoadEnded] = useState<boolean>(false)

  // 部所権限ComboBox
  const [部所権限ComboBox, set部所権限ComboBox] = useState<TWijmoComboBox<
    string,
    T部所権限マスタ
  > | null>(null)
  const [部所権限ItemSource, set部所権限ItemSource] =
    useState<T部所権限マスタ[]>()
  const [部所権限isLoadEnded, set部所権限isLoadEnded] = useState<boolean>(false)

  //#endregion

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [is市区町村ModalShow, setIs市区町村ModalShow] = useState(false)

  //#endregion

  //#region [method]

  const set市区町村 = (value: T市区町村) => {
    set点呼場所団体コード(value.団体コード)
    set点呼場所市区町村名(value.市区町村名漢字)
  }

  /**
   * データ取得
   */
  const getData = async (id: number, signal: AbortSignal) => {
    const service = new BusyoService()

    try {
      const res = await service.get(id, signal)
      if (res.data) {
        // TODO:詰め方をチェック
        set会社コード(res.data.会社コード)
        set営業所管コード(res.data.営業所管コード)
        set営業所コード(res.data.営業所コード)
        set部所コード(res.data.部所コード)
        set部所名(res.data.部所名)
        set部所略称(res.data.部所略称)
        set運行部所フラグ(res.data.運行部所フラグ ?? 0)
        set点呼場所団体コード(res.data.団体コード)
        set点呼場所市区町村名(res.data.市区町村名漢字)
        set部所権限コード(res.data.部所権限コード)
        set最終更新日時(res.data.更新日時)
        set最終更新ID(
          res.data.更新ユーザID ? res.data.更新ユーザID.toString() : ""
        )
      }
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)
    let schema
    if (id) {
      schema = busyoUpdatePutReqSchema
    } else {
      schema = busyoRegisterPostReqSchema
    }
    const validate = ajv.compile(schema)

    const data = {
      会社コード,
      営業所管コード,
      営業所コード,
      部所コード,
      部所名,
      部所略称,
      運行部所フラグ,
      点呼場所団体コード,
      部所権限コード,
      更新日時: 最終更新日時 ? 最終更新日時.toString() : "",
    }
    const validateResult = validate(data)

    if (!validateResult) {
      const errors = validate.errors

      if (errors != null && errors.length > 0) {
        //エラーメッセージのparamsより対象の項目を発見し色変え
        setValidateError(errors)
        disPatch(
          setWarningAlerts([
            ...errors
              .filter((e) => e.message != null)
              .map((e) => e.message ?? ""),
          ])
        )
      }
      return
    }
    setIsConfirmModalShow(true)
  }

  /**
   * エラー発生時の項目色変え
   * @param errors
   */
  const setValidateError = (
    errors: ErrorObject<string, Record<string, any>, unknown>[]
  ) => {
    const instancePaths = errors.map((e) => e.instancePath.replaceAll("/", ""))
    const requiredProperties = errors
      .filter(
        (e) =>
          e.instancePath === "" &&
          e.params.errors.length > 0 &&
          e.params.errors.find(
            (ec: { keyword: string }) => ec.keyword === "required"
          )
      )
      .map((e) => {
        const error = e.params.errors[0]
        return error.params.missingProperty
      })
    const errorProperties = [...instancePaths, ...requiredProperties]

    setIsInvalid会社コード(errorProperties.includes("会社コード"))
    setIsInvalid営業所管コード(errorProperties.includes("営業所管コード"))
    setIsInvalid営業所コード(errorProperties.includes("営業所コード"))
    setIsInvalid部所コード(errorProperties.includes("部所コード"))
    setIsInvalid部所名(errorProperties.includes("部所名"))
    setIsInvalid部所略称(errorProperties.includes("部所略称"))
    setIsInvalid点呼場所団体コード(errorProperties.includes("市区町村コード"))
    setIsInvalid点呼場所市区町村名(errorProperties.includes("市区町村コード"))
    setIsInvalid部所権限コード(errorProperties.includes("部所権限コード"))
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      // バリデーション完了後のため数値は正常だが エラー回避のためここでも確認
      if (
        会社コード == null ||
        営業所管コード == null ||
        営業所コード == null ||
        部所コード == null ||
        部所名 == null ||
        部所略称 == null ||
        運行部所フラグ == null
      )
        return

      let data = {
        会社コード,
        営業所管コード,
        営業所コード,
        部所コード,
        部所名,
        部所略称,
        運行部所フラグ,
        点呼場所団体コード,
        部所権限コード: 部所権限コード ?? "",
        更新日時: 最終更新日時 ? 最終更新日時.toString() : "",
      }
      const service = new BusyoService()

      let res: TApiResponse<boolean>
      if (id) {
        res = await service.put(id, data)
      } else {
        res = await service.post(data)
      }
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`部所マスタの${id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }
  //#endregion

  //#region [effect]

  //初期設定
  useEffect(() => {
    //画面全体ロック
    disPatch(画面ロック開始())

    const abortController = new AbortController()

    Promise.all([
      new KaisyaService().getList(),
      new EigyosyoKanService().getList(),
      new EigyosyoService().getList(),
      new BusyoKengenService().getList(),
    ]).then(([会社Res, 営業所管Res, 営業所Res, 部所権限Res]) => {
      //TODO: API より取得
      会社Res && set会社ItemSource(会社Res.data)
      営業所管Res && set営業所管ItemSource(営業所管Res.data)
      営業所Res && set営業所ItemSource(営業所Res.data)
      部所権限Res && set部所権限ItemSource(部所権限Res.data)
      // id存在時はデータを取得し更新
      if (id) {
        getData(id, abortController.signal).finally(() => {
          disPatch(画面ロック解除())
          // ファイルロード後、戻るボタン押下時に警告が出るように変更
          isPrompt.current = !読取専用フラグ
        })
      } else {
        set会社コード("")
        set営業所管コード("")
        set営業所コード("")
        set部所権限コード("")
        disPatch(画面ロック解除())
        // ファイルロード後、戻るボタン押下時に警告が出るように変更
        isPrompt.current = !読取専用フラグ
      }
    })

    return () => {
      abortController.abort()
    }
  }, [])

  // 会社、営業所菅の切替に合わせて営業所の表示データを変更
  useEffect(() => {
    if (
      営業所ComboBox == null ||
      !会社isLoadEnded ||
      !営業所管isLoadEnded ||
      !営業所isLoadEnded
    )
      return
    営業所ComboBox.collectionView.filter = (item) => {
      return (
        item.会社コード === 会社コード && item.営業所管コード === 営業所管コード
      )
    }
    営業所ComboBox.collectionView.refresh()
    営業所ComboBox.refresh()
    if (営業所ComboBox.collectionView.items.length === 0) {
      set営業所コード("")
    }
  }, [
    会社コード,
    営業所管コード,
    営業所ComboBox,
    会社isLoadEnded,
    営業所管isLoadEnded,
    営業所isLoadEnded,
  ])

  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">部所マスタ{id ? `更新` : `登録`}</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-70rem">
              <Card.Body>
                <Container fluid className="register-form">
                  {/* 会社 */}
                  <MasterRegisterFormRow label="会社">
                    <ComboBox.Kaisya
                      itemsSource={会社ItemSource}
                      isLoadEnded={会社isLoadEnded}
                      setIsLoadEnded={set会社isLoadEnded}
                      selectedValue={会社コード}
                      setSelectedValue={set会社コード}
                      isRequired={true}
                      isEmpty={true}
                      className={isInvalid会社コード ? "is-error" : ""}
                      ComboBox={会社ComboBox}
                      setComboBox={set会社ComboBox}
                      autoFocus={true}></ComboBox.Kaisya>
                  </MasterRegisterFormRow>
                  {/* 営業所管 */}
                  <MasterRegisterFormRow label="営業所管">
                    <ComboBox.Eigyosyokan
                      itemsSource={営業所管ItemSource}
                      isLoadEnded={営業所管isLoadEnded}
                      setIsLoadEnded={set営業所管isLoadEnded}
                      isRequired={true}
                      isEmpty={true}
                      selectedValue={営業所管コード}
                      setSelectedValue={set営業所管コード}
                      className={isInvalid営業所管コード ? "is-error" : ""}
                      ComboBox={営業所管ComboBox}
                      setComboBox={set営業所管ComboBox}></ComboBox.Eigyosyokan>
                  </MasterRegisterFormRow>
                  {/* 営業所 */}
                  <MasterRegisterFormRow label="営業所" isRequired={true}>
                    <ComboBox.Eigyosyo
                      itemsSource={営業所ItemSource}
                      isLoadEnded={営業所isLoadEnded}
                      setIsLoadEnded={set営業所isLoadEnded}
                      selectedValue={営業所コード}
                      isRequired={true}
                      isEmpty={true}
                      setSelectedValue={set営業所コード}
                      className={isInvalid営業所コード ? "is-error" : ""}
                      ComboBox={営業所ComboBox}
                      setComboBox={set営業所ComboBox}></ComboBox.Eigyosyo>
                  </MasterRegisterFormRow>
                  {/* 部所コード */}
                  <MasterRegisterFormRow
                    label="部所コード"
                    isRequired={true}
                    remarks={<div>数字4桁まで</div>}>
                    <TextInput
                      style={{ width: "5rem" }}
                      id="部所コード"
                      name="部所コード"
                      value={部所コード}
                      setValue={set部所コード}
                      className={isInvalid部所コード ? "is-error" : ""}
                      maxLength={CONSTANT.validateConstant.LENGTH.部所コード}
                    />
                  </MasterRegisterFormRow>
                  {/* 部所名 */}
                  <MasterRegisterFormRow label="部所名" isRequired={true}>
                    <div className="w-15rem">
                      <TextInput
                        id="部所名"
                        name="部所名"
                        value={部所名}
                        setValue={set部所名}
                        className={isInvalid部所名 ? "is-error" : ""}
                        maxLength={CONSTANT.validateConstant.LENGTH.一般名称}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 部所略称 */}
                  <MasterRegisterFormRow label="部所略称" isRequired={true}>
                    <div className="w-15rem">
                      <TextInput
                        id="部所略称"
                        name="部所略称"
                        value={部所略称}
                        setValue={set部所略称}
                        className={isInvalid部所略称 ? "is-error" : ""}
                        maxLength={CONSTANT.validateConstant.LENGTH.一般名称}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 運行部所フラグ */}
                  <MasterRegisterFormRow
                    label="運行部所フラグ"
                    isRequired={true}>
                    <div className="w-15rem">
                      <CheckInput
                        id="運行部所フラグ"
                        type={"switch"}
                        label={""}
                        value={運行部所フラグ}
                        setValue={(v) => {
                          v === 1 ? set運行部所フラグ(v) : set運行部所フラグ(0)
                        }}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 点呼場所市区町村 */}
                  <MasterRegisterFormRow
                    label="点呼場所市区町村"
                    remarks={<div>点呼場所の初期値に設定されます</div>}>
                    {/* 点呼場所市区町村 */}
                    <div className="w-13rem">
                      <TextInput
                        id="点呼場所市区町村名"
                        name="点呼場所市区町村名"
                        value={点呼場所市区町村名}
                        setValue={set点呼場所市区町村名}
                        className={
                          isInvalid点呼場所団体コード ||
                          isInvalid点呼場所市区町村名
                            ? "is-error"
                            : ""
                        }
                        isReadOnly={true}
                      />
                    </div>
                    {/* TODO:市区町村検索モーダルの実装 */}
                    <button
                      type="button"
                      onClick={() => {
                        setIs市区町村ModalShow(true)
                      }}
                      className="icon-button">
                      <FontAwesomeIcon
                        className="icon-button-inner"
                        icon={faSearch}></FontAwesomeIcon>
                    </button>
                  </MasterRegisterFormRow>
                  {/* 部所権限 */}
                  <MasterRegisterFormRow
                    label="部所権限グループ"
                    isRequired={true}
                    remarks={<div></div>}>
                    <div className="w-25rem">
                      <ComboBox.BusyoKengen
                        itemsSource={部所権限ItemSource}
                        isLoadEnded={部所権限isLoadEnded}
                        setIsLoadEnded={set部所権限isLoadEnded}
                        selectedValue={部所権限コード}
                        isRequired={true}
                        isEmpty={true}
                        setSelectedValue={set部所権限コード}
                        className={isInvalid部所権限コード ? "is-error" : ""}
                        ComboBox={部所権限ComboBox}
                        setComboBox={
                          set部所権限ComboBox
                        }></ComboBox.BusyoKengen>
                    </div>
                  </MasterRegisterFormRow>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {id && (
          <>
            <Row>
              <Col>
                最終更新日時:
                {util.date.format(最終更新日時, "YYYY/MM/DD HH:mm:ss")}
              </Col>
            </Row>
            <Row>
              <Col>最終更新ID : {最終更新ID}</Col>
            </Row>
          </>
        )}
        <Row className="search-button">
          {!読取専用フラグ && (
            <Col xl={{ span: "auto", offset: 0 }}>
              <Button
                type="submit"
                variant="waiting"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  beforeSubmit()
                }}>
                {id ? `更新` : `登録`}
              </Button>
            </Col>
          )}
          <Col>
            <Button
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
          </Col>
        </Row>
      </Container>
      <SikutyosonSearchModal
        isShow={is市区町村ModalShow}
        setIsShow={setIs市区町村ModalShow}
        setData={set市区町村}></SikutyosonSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
    </>
  )
}

export default MasterBusyoRegister
